:host {
  .chat-message-text {
    color: #666666;
    color: var(--font-secondary);
  }

  .chat-message-text--right {
    color: white;
  }
}
